  <div class="ontario-loading-indicator__overlay" role="alert" aria-live="assertive">
  	<div class="ontario-loading-indicator">
  		<svg class="ontario-loading-indicator__spinner" viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
         <circle cx="50" cy="50" r="20" fill="none" stroke-width="4"></circle>
  		</svg>
  		<p>Progressing...</p>
  	</div>
  </div>
